// export { default as profile } from "./profile";
// export { default as rfq } from "./rfq";

import profile from "./profile";
import rfq from "./rfq";
import priceUpdater from "./priceUpdater";


const modules = [profile, priceUpdater];

export default modules;
